(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sel = ['.nle-copy > *','.nlo-head','.nlo-grid > a','.nlb-box > *','.nlc2-wrap > div:first-child > *','.nlp-head','.nlp-tabs','[class*="nlp-row"] > li','[class*="of-row"] > li','.ofertas-header','.multicolumn-card','.multicolumn .title-wrapper-with-link'];
  var pending = [];
  document.querySelectorAll(sel.join(',')).forEach(function(el){
    var idx = Array.prototype.indexOf.call(el.parentElement.children, el);
    el.style.setProperty('--d', (Math.min(idx, 8) * 0.07) + 's');
    el.classList.add('nl-rv');
    pending.push(el);
  });
  document.querySelectorAll('.nlx-wrap').forEach(function(el){ pending.push(el); });
  if (reduce) { pending.forEach(function(e){ e.classList.add('is-in'); }); return; }
  var img = document.querySelector('.nle-card > img'), hero = document.querySelector('.nle-dark');
  var busy = false;
  function tick(){
    busy = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    pending = pending.filter(function(el){
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92) { el.classList.add('is-in'); return false; }
      return true;
    });
    if (img && hero) {
      var h = hero.getBoundingClientRect();
      var p = Math.min(Math.max(-h.top / (h.height || 1), 0), 1);
      img.style.setProperty('--z', (1.14 - 0.14 * Math.min(1, p * 1.8)).toFixed(4));
      img.style.setProperty('--y', (p * 36).toFixed(1) + 'px');
    }
  }
  function req(){ if (!busy) { busy = true; setTimeout(tick, 16); } }
  addEventListener('scroll', req, { passive: true });
  addEventListener('resize', req);
  addEventListener('load', tick);
  tick();
  setTimeout(tick, 400);
})();
